import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'admin-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  routeActive: string;
  showDeviceDelivery: any;
  showResourcesSubMenu = false;
  isResourcesLinkActice = false;
  resourcesSubMenuLinkTitles = ['Audio Pods', 'Science', 'Community'];

  constructor(
    public authService: AuthService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.routeActive = this.route.snapshot.data.title;
    this.showDeviceDelivery = environment.includeDeviceDelivery;

    if (this.resourcesSubMenuLinkTitles.indexOf(this.routeActive) >= 0) {
      this.showResourcesSubMenu = true;
      this.isResourcesLinkActice = true;
    }
  }

}
